import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, Inject, OnInit, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { EnableEscCloseDirective, UiAutofocusDirective, UiButtonComponent } from '@ui';
import { PersonGroupsModel } from '@models/person-groups.model';
import { AppState } from '../../../../../../store/app.state';
import { personGroupsFeature } from '@states/person-groups/person-groups.feature';

@Component({
  selector: 'app-group-name-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    UiButtonComponent,
    A11yModule,
    UiAutofocusDirective,
  ],
  templateUrl: './group-name-dialog.component.html',
  styleUrl: './group-name-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [EnableEscCloseDirective]
})
export class GroupNameDialogComponent implements OnInit {
  private readonly store$ = inject(Store<AppState>);

  protected readonly isCreatingPersonGroup = this.store$.selectSignal(personGroupsFeature.selectIsCreatingPersonGroup);

  public readonly nameControl = new FormControl('', [Validators.required]);
  public readonly continueClicked = new Subject<string>();
  public duplicateName = '';
  public titleKey = 'PERSON_GROUPS.NAME_DIALOG.CREATE_TITLE';
  public submitKey = 'COMMON.CONTINUE';

  public constructor(
    private readonly dialogRef: MatDialogRef<GroupNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data?: PersonGroupsModel.GroupNameDialogData,
  ) {}

  public ngOnInit(): void {
    if (this.data?.initialName != null && this.data.initialName !== '') {
      this.nameControl.setValue(this.data.initialName);
    }
    if (this.data?.titleKey) {
      this.titleKey = this.data.titleKey;
    }
    if (this.data?.submitKey) {
      this.submitKey = this.data.submitKey;
    }
  }

  public onContinue(): void {
    if (this.isCreatingPersonGroup()) {
      return;
    }
    const name = this.nameControl.value?.trim();
    if (!name) {
      return;
    }
    this.continueClicked.next(name);
  }

  public onCancel(): void {
    if (this.isCreatingPersonGroup()) {
      return;
    }
    this.dialogRef.close(null);
  }

  public setDuplicateError(name: string): void {
    this.nameControl.setErrors({ duplicate: true });
    this.duplicateName = name;
  }
}
